// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3PDyk","loaderOuter":"PageOverlayLoader_loaderOuter__30RFi"};